module.exports = __webpack_public_path__ + "static/fonts/AvenirLTStd-Roman.1675e895.woff";